import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import styles from './ReleaseNoteForm.module.css'

import FormControl from 'Design/components/FormControl'
import Label from 'Design/components/Label'
import Input from 'Design/components/Input'
import Button from 'Design/components/Button'
import FormErrorText from 'Design/components/FormErrorText'
import { useUploadImageMutation } from '../release-notes.service'
import ProductPicker from '../../Products/ProductPicker'
import { DatePicker } from '../../../../../components/DatePicker'

import TrixEditor from 'Src/b/components/TrixEditor'

const ReleaseNoteForm = (props) => {
  const { mode = 'create', isLoading, onSubmit, onDelete, onSaveAndAddNewReleaseNote } = props

  const {
    register,
    control,
    handleSubmit,
    formState: { isSubmitting, errors }
  } = useFormContext()

  const [uploadImage, uploadImageResult] = useUploadImageMutation()
  const disableSubmitButton = isSubmitting || isLoading || uploadImageResult.isLoading

  const handleImageUpload = async (event) => {
    const attachment = event.attachment

    if (attachment.file) {
      try {
        const formData = new FormData()
        formData.append('file', attachment.file)

        const data = await uploadImage(formData).unwrap()
        const { fileUrl } = data

        attachment.setAttributes({
          url: fileUrl,
          href: fileUrl
        })
      } catch (error) {
        console.error('Error while uploading image to server', error)
      }
    }
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormControl isInvalid={errors.product_id}>
        <Label>Product</Label>
        <Controller
          control={control}
          name='product'
          render={({ field: { value, onChange } }) => {
            return (
              <ProductPicker
                isDisabled={mode === 'edit'}
                defaultValue={value}
                onChange={onChange}
                className={styles.ProductPicker}
              />
            )
          }}
        />
        {errors.product_id && <FormErrorText>{errors.product_id.message}</FormErrorText>}
      </FormControl>

      <FormControl isInvalid={errors.release_date}>
        <Label>Date</Label>
        <Controller
          control={control}
          name='release_date'
          render={({ field: { value, onChange: onDateChange } }) => {
            return (
              <DatePicker
                maxDate={new Date()}
                value={new Date(value)}
                placeholder='Select a date'
                className={styles.DatePicker}
                onChange={(value) => {
                  return onDateChange(new Date(value).toISOString())
                }}
              />
            )
          }}
        />
        {errors.release_date && <FormErrorText>{errors.release_date.message}</FormErrorText>}
      </FormControl>

      <FormControl isInvalid={errors.title}>
        <Label>Title</Label>
        <Input className={styles.TitleInput} {...register('title')} />
        {errors.title && <FormErrorText>{errors.title.message}</FormErrorText>}
      </FormControl>

      <FormControl isInvalid={errors.body}>
        <Label>Body</Label>
        <Controller
          control={control}
          name='body'
          render={({ field: { value, onChange } }) => {
            return <TrixEditor defaultValue={value} onChange={onChange} onImageUpload={handleImageUpload} />
          }}
        />
        {errors.body && <FormErrorText>{errors.body.message}</FormErrorText>}
      </FormControl>

      <div className={styles.ButtonContainer}>
        <Button variant='primary' type='submit' disabled={disableSubmitButton}>
          Save
        </Button>

        {onSaveAndAddNewReleaseNote && (
          <Button
            className={styles.AddNewReleaseNoteButton}
            variant='secondary'
            onClick={handleSubmit(onSaveAndAddNewReleaseNote)}
            disabled={disableSubmitButton}
          >
            Save and add new release note
          </Button>
        )}

        {onDelete && (
          <Button className={styles.DeleteButton} variant='link-danger' onClick={onDelete}>
            Delete
          </Button>
        )}
      </div>
    </form>
  )
}

export default ReleaseNoteForm
